import React from "react";

export default function WebsiteMock({ accentColor }) {
  return (
    <div className="cz-site-mock">
      <div className="cz-site-nav">
        <span className="cz-site-logo">ACME</span>
        <nav>
          <span>Products</span>
          <span>Solutions</span>
          <span>Pricing</span>
          <span>Resources</span>
        </nav>
        <button type="button" style={{ background: accentColor }}>
          Get started
        </button>
      </div>

      <div className="cz-site-hero">
        <div className="cz-site-hero-text">
          <h3>
            Modern hosting for
            <br />
            growing businesses
          </h3>
          <p>Reliable, fast and secure hosting solutions built for scale.</p>
          <div className="cz-site-hero-actions">
            <button type="button" style={{ background: accentColor }}>
              Get started
            </button>
            <span>Learn more &rarr;</span>
          </div>
        </div>
        <div className="cz-site-hero-art">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
